export enum CustomRow {
  Primary = 'custom-row-title_primary',
  Secondary = 'custom-row-title_secondary',
  White = 'custom-row-title_white',
  Red = 'custom-row-title_red',
  Orange = 'custom-row-title_orange',
}
